import { faEllipsisVertical, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Button, Card, Col, Container, Dropdown, Form, Image, Row, Table } from "react-bootstrap";
import { AssignImg, Delete_2, Edit_2, Eye_2, Filters } from "../../../../../assets/images";
import * as Constants from '../../../../Helper/constants/constants';
import WithoutImageHeader from "../../../../Helper/withoutImageHeader";
import PaginationComponent from "../../../CommanComponents/Pagination";
import FilterModal from "../../../Modals/FilterModal";

const ManagePatientList = () => {
    var breadcrumData = ['Dashboard', 'Manage Patient'];
    var breadcrumItem = ['Patient List'];
    const [searchInput, setSearchInput] = useState("");
    const handleChange = (e) => {
        setSearchInput(e.target.value);
    };
    const [showFilterModal, setShowFilterModal] = useState(false);
    return (
        <div className="manage_patient_list_screen">
            <WithoutImageHeader
                header={Constants.PATIENT_DETAILS_HEADER}
                breadcrumData={breadcrumData}
                breadcrumItem={breadcrumItem}
            />

            <Container>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className="patient_list_details">
                            <div className="title_btn_area">
                                <div className="left_area">
                                    <h3>Patient List</h3>
                                </div>
                                <div className="right_area">
                                    <Button className="btn btn-primary" type="button">Add Patient</Button>
                                </div>
                            </div>
                            <div className="search_section">
                                <div className="search_left_area">
                                    <Form>
                                        <Form.Group className="form-group">
                                            <Form.Control
                                                type="text"
                                                placeholder="Search"
                                                value={searchInput}
                                                onChange={handleChange}
                                            />
                                            <a href="javascript:;">
                                                <div className="icon">
                                                    <FontAwesomeIcon icon={faSearch} />
                                                </div>
                                            </a>
                                        </Form.Group>
                                    </Form>
                                </div>
                                <div className="search_right_area">
                                    <Form>
                                        <Form.Group className="form-group select_pagination">
                                            <Form.Select>
                                                <option>5</option>
                                                <option>10</option>
                                                <option>15</option>
                                                <option>20</option>
                                                <option>25</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Form>
                                    <Button className="filter_button" onClick={() => setShowFilterModal(true)}><Image src={Filters} alt="..." />Filters</Button>
                                </div>
                            </div>
                            <div className="list_detail">
                                <div className="list_data">
                                    <Card>
                                        <Card.Body>
                                            <Table responsive>
                                                <tr>
                                                    <th>Patient Name</th>
                                                    <th>Ward</th>
                                                    <th>Room</th>
                                                    <th>Bed</th>
                                                    <th>Status</th>
                                                    <th>Date of Admission</th>
                                                    <th>Action</th>
                                                </tr>
                                                <tr>
                                                    <td >
                                                        <div className="data_table">
                                                            <div className="left_area">
                                                                <div className="img_area">
                                                                    <Image src={AssignImg} alt="..." />
                                                                </div>
                                                            </div>
                                                            <div className="right_areaa">
                                                                <h4>Robert William</h4>
                                                                <p className="patient_number">7DH5738H</p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <p><span className="designation">Cardiology</span></p>
                                                    </td>
                                                    <td>05</td>
                                                    <td>05</td>
                                                    <td>
                                                        <div className="badge">
                                                            <p class="warning">Under Treatment</p>
                                                        </div>
                                                    </td>
                                                    <td>23/04/2022 (12:00 PM)</td>
                                                    <td>
                                                        <div className="icon">
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="none" id="dropdown-basic">
                                                                    <FontAwesomeIcon icon={faEllipsisVertical} className="ellipsis_icon" />
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item href="javascript:;">View <Image src={Eye_2} alt="..." className="image_area" /></Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">
                                                                        Edit
                                                                        <Image src={Edit_2} alt="..." className="image_area" />
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">Delete
                                                                        <Image src={Delete_2} alt="..." className="image_area delete_icon " />
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td >
                                                        <div className="data_table">
                                                            <div className="left_area">
                                                                <div className="img_area">
                                                                    <Image src={AssignImg} alt="..." />
                                                                </div>
                                                            </div>
                                                            <div className="right_areaa">
                                                                <h4>Robert William</h4>
                                                                <p className="patient_number">7DH5738H</p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <p><span className="designation">Cardiology</span></p>
                                                    </td>
                                                    <td>05</td>
                                                    <td>05</td>
                                                    <td>
                                                        <div className="badge">
                                                            <p class="danger">Critical</p>
                                                        </div>
                                                    </td>
                                                    <td>23/04/2022 (12:00 PM)</td>
                                                    <td>
                                                        <div className="icon">
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="none" id="dropdown-basic">
                                                                    <FontAwesomeIcon icon={faEllipsisVertical} className="ellipsis_icon" />
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item href="javascript:;">View <Image src={Eye_2} alt="..." className="image_area" /></Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">
                                                                        Edit
                                                                        <Image src={Edit_2} alt="..." className="image_area" />
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">Delete
                                                                        <Image src={Delete_2} alt="..." className="image_area delete_icon " />
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td >
                                                        <div className="data_table">
                                                            <div className="left_area">
                                                                <div className="img_area">
                                                                    <Image src={AssignImg} alt="..." />
                                                                </div>
                                                            </div>
                                                            <div className="right_areaa">
                                                                <h4>Robert William</h4>
                                                                <p className="patient_number">7DH5738H</p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <p><span className="designation">Cardiology</span></p>
                                                    </td>
                                                    <td>05</td>
                                                    <td>05</td>
                                                    <td>
                                                        <div className="badge">
                                                            <p class="warning">Under Treatment</p>
                                                        </div>
                                                    </td>
                                                    <td>23/04/2022 (12:00 PM)</td>
                                                    <td>
                                                        <div className="icon">
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="none" id="dropdown-basic">
                                                                    <FontAwesomeIcon icon={faEllipsisVertical} className="ellipsis_icon" />
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item href="javascript:;">View <Image src={Eye_2} alt="..." className="image_area" /></Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">
                                                                        Edit
                                                                        <Image src={Edit_2} alt="..." className="image_area" />
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">Delete
                                                                        <Image src={Delete_2} alt="..." className="image_area delete_icon " />
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td >
                                                        <div className="data_table">
                                                            <div className="left_area">
                                                                <div className="img_area">
                                                                    <Image src={AssignImg} alt="..." />
                                                                </div>
                                                            </div>
                                                            <div className="right_areaa">
                                                                <h4>Robert William</h4>
                                                                <p className="patient_number">7DH5738H</p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <p><span className="designation">Cardiology</span></p>
                                                    </td>
                                                    <td>05</td>
                                                    <td>05</td>
                                                    <td>
                                                        <div className="badge">
                                                            <p class="success">Admitted</p>
                                                        </div>
                                                    </td>
                                                    <td>23/04/2022 (12:00 PM)</td>
                                                    <td>
                                                        <div className="icon">
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="none" id="dropdown-basic">
                                                                    <FontAwesomeIcon icon={faEllipsisVertical} className="ellipsis_icon" />
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item href="javascript:;">View <Image src={Eye_2} alt="..." className="image_area" /></Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">
                                                                        Edit
                                                                        <Image src={Edit_2} alt="..." className="image_area" />
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">Delete
                                                                        <Image src={Delete_2} alt="..." className="image_area delete_icon " />
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td >
                                                        <div className="data_table">
                                                            <div className="left_area">
                                                                <div className="img_area">
                                                                    <Image src={AssignImg} alt="..." />
                                                                </div>
                                                            </div>
                                                            <div className="right_areaa">
                                                                <h4>Robert William</h4>
                                                                <p className="patient_number">7DH5738H</p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <p><span className="designation">Cardiology</span></p>
                                                    </td>
                                                    <td>05</td>
                                                    <td>05</td>
                                                    <td>
                                                        <div className="badge">
                                                            <p class="discharge">Discharge</p>
                                                        </div>
                                                    </td>
                                                    <td>23/04/2022 (12:00 PM)</td>
                                                    <td>
                                                        <div className="icon">
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="none" id="dropdown-basic">
                                                                    <FontAwesomeIcon icon={faEllipsisVertical} className="ellipsis_icon" />
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item href="javascript:;">View <Image src={Eye_2} alt="..." className="image_area" /></Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">
                                                                        Edit
                                                                        <Image src={Edit_2} alt="..." className="image_area" />
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">Delete
                                                                        <Image src={Delete_2} alt="..." className="image_area delete_icon " />
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </Table>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
            <PaginationComponent />
            {
                showFilterModal ? (
                    <FilterModal show={showFilterModal} close={() => setShowFilterModal(false)} />
                ) : null
            }
        </div>
    )
}

export default ManagePatientList;